import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { resolvePunditImageUrl } from '../utils/imageUrl';

const PoojaLibrary = () => {
  const [poojas, setPoojas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/punditpurohit/pooja-library`)
      .then((res) => res.json())
      .then((data) => setPoojas(Array.isArray(data) ? data : []))
      .catch((err) => {
        console.error('Unable to load pooja library', err);
        setPoojas([]);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="library-wrapper">
      <header className="library-header">
        <h1>Ritual Wisdom Library</h1>
        <p>Explore the spiritual significance, benefits, and ancient traditions behind every ceremony.</p>
      </header>

      <div className="library-grid">
        {loading ? (
          <p>Loading library...</p>
        ) : poojas.map((pooja) => (
          <motion.div key={pooja.id} whileHover={{ y: -8 }} className="library-card">
            <div className="library-card-img">
              <img src={resolvePunditImageUrl(pooja.images?.[0] || pooja.gallery?.[0])} alt={pooja.name} />
            </div>
            <div className="library-card-content">
              <h3>{pooja.name}</h3>
              <p className="short-desc">
                {(pooja.significance || pooja.description || '').substring(0, 100)}...
              </p>
              <div className="benefit-tags">
                {(pooja.whyPerform || []).slice(0, 2).map((benefit, i) => (
                  <span key={i} className="b-tag">{benefit.split(' ')[1] || benefit}</span>
                ))}
              </div>
              <Link to={`/uc/pooja-details/${pooja.id}`} className="read-more-btn">
                Explore Ritual Details
              </Link>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default PoojaLibrary;
